import { render } from "./WhyAdoptADrainCarousel.vue?vue&type=template&id=3f2eea35"
import script from "./WhyAdoptADrainCarousel.vue?vue&type=script&lang=js"
export * from "./WhyAdoptADrainCarousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__